/* eslint-disable */
import React,{ useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import { AESEncryptionParam, AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import services from '../Service';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import ImageUploader from 'react-images-upload';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Input from '@material-ui/core/Input';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { stubTrue } from 'lodash';
import { lighten, makeStyles } from '@material-ui/styles';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import AddeditProduct from './AddeditProduct'

//Sort Table
function createData(idNo, pname, productPrice, qtyNum, aPrice, rePrice, action) {
  return { idNo, pname, productPrice, qtyNum, aPrice, rePrice, action };
}

const rows = [
  createData(1, 'Ash Plantation', 100.00, 100, 95, 200.00),
  createData(2, 'Beef Tomato', 75.50, 250, 70, 270.00),
  createData(3, 'Capaicum', 65.25, 75, 65, 150.00),
  createData(4, 'Pumkin', 0, 0, 0, 0)
];


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'idNo',
    numeric: true,
    disablePadding: false,
    label: '#'
  },
  { id: 'pname', numeric: true, disablePadding: false, label: 'Product' },
  {
    id: 'productPrice',
    numeric: true,
    disablePadding: false,
    label: 'Proposed Price(LKR)'
  },
  {
    id: 'qtyNum',
    numeric: true,
    disablePadding: false,
    label: 'Proposed Qty(Kg)'
  },
  {
    id: 'aPrice',
    numeric: true,
    disablePadding: false,
    label: 'Approved Price(LKR)'
  },
  {
    id: 'rePrice',
    numeric: true,
    disablePadding: false,
    label: 'Realized Price(LKR)'
  },
  { id: 'action', numeric: true, disablePadding: false, label: 'Actions' }
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles((theme) => ({

  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  }
}));

export default function PriceView(props) {
  const navigate = useNavigate();
  const { productID } = useParams();
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: true,
    submitButtonName: 'Update',
    pageheadername: 'Collection Center Wise'
  });
  const [isTable, setIsTable] = useState(false);
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const bntStyle = {
    backgroundColor: '#07AB31',
    color: 'white',
    fontWeight: 'bolder'
  };
  const [date, setDate] = React.useState(new Date());

  const [formData, setFormData] = useState({
    groupID: '1',
    operationEntityID: '1',
    collectionCenterID: '0',
    dataID: date.toISOString().split('T')[0]
  });

  const priceOrderUpdateSearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number()
      .min(1, 'Please Select Operation Entity')
      .required('Operation Entity required'),
    collectionCenterID: Yup.number()
      .required('Collecion Center required'),
    dateID: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      collectionCenterID: formData.collectionCenterID,
      dateID: formData.dataID
    },

    validationSchema: priceOrderUpdateSearchSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        setIsTable(true);
      } else {
        SubmitForm();
      }
    }
  });

  async function SubmitForm() {
    toast.success('Price Update Succesfully');
  }
  async function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const [ImageObject, setImageObject] = useState();
  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  async function UpdatePrice(values) {
    toast.success('Price Update Succesfully');
  }
  async function clearAll() {
    formik.resetForm();
    setIsTable(false);
  }

  //Sort Table
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <Page title="Collection Center Wise  |  Agri-Connect">
      <Container>
        <CommonPageHeader path={"/dashboard/priceView/addedit/" + AESEncryptionParam("0")} btname="Next" pageName={pageProps.pageheadername} leftButtonHidden={true} />
        <FormikProvider value={formik}>
          <ToastContainer position="bottom-right" pauseOnHover />
          <Form
            autoComplete="off"
            disabled={!(formik.isValid && formik.dirty)}
            noValidate
            onSubmit={handleSubmit}
          >
            <Stack spacing={2}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Group *"
                  value={formik.values.groupID}
                  onChange={formik.handleChange}
                  {...getFieldProps('groupID')}
                  error={Boolean(touched.groupID && errors.groupID)}
                  helperText={touched.groupID && errors.groupID}
                >
                  <MenuItem key={0} value={0}>
                    {' '}
                    Select Group
                  </MenuItem>
                  <MenuItem value={1}> Cargills</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Operation Entity *"
                  value={formik.values.operationEntityID}
                  onChange={formik.handleChange}
                  {...getFieldProps('operationEntityID')}
                  error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                  helperText={touched.operationEntityID && errors.operationEntityID}
                >
                  <MenuItem key={0} value={0}>
                    {' '}
                    Select Operation Entity
                  </MenuItem>
                  <MenuItem value={1}> Cargills</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Collection Center *"
                  value={formik.values.collectionCenterID}
                  onChange={formik.handleChange}
                  {...getFieldProps('collectionCenterID')}
                  error={Boolean(touched.collectionCenterID && errors.collectionCenterID)}
                  helperText={touched.collectionCenterID && errors.collectionCenterID}
                >
                  <MenuItem key={0} value={0}>All Collection Center</MenuItem>
                  <MenuItem value={1}> Thanamalvila</MenuItem>
                  <MenuItem value={2}> Nuwara Eliya</MenuItem>
                </TextField>
                <TextField
                  fullWidth
                  id="outlined-start-adornment"
                  size="small"
                  label="Date *"
                  type="Date"
                  value={formik.values.dateID}
                  onChange={formik.handleChange}
                  {...getFieldProps('dateID')}
                  error={Boolean(touched.dateID && errors.dateID)}
                  helperText={touched.dateID && errors.dateID}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"></InputAdornment>
                  }}
                ></TextField>
              </Stack>
              <br />

              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                  {' '}
                  Clear
                </Button>

                <Button type="submit" color="secondary" variant="outlined">
                  Search
                </Button>
              </Stack>

              <br />
              <Divider variant="middle" />
              <br />

              <>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Card style={{ justifycontent: 'center', width: '85rem' }}>
                    <TableContainer>
                      <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table"
                      >
                        <EnhancedTableHead
                          classes={classes}
                          numSelected={selected.length}
                          order={order}
                          orderBy={orderBy}
                          onSelectAllClick={handleSelectAllClick}
                          onRequestSort={handleRequestSort}
                          rowCount={rows.length}
                        />
                        <TableBody>
                          {stableSort(rows, getComparator(order, orderBy))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              const isItemSelected = isSelected(row.name);
                              const labelId = `enhanced-table-checkbox-${index}`;

                              return (
                                <TableRow
                                  hover
                                  onClick={(event) => handleClick(event, row.name)}
                                  tabIndex={-1}
                                  key={row.name}
                                >
                                  <TableCell align="center">{row.idNo}</TableCell>
                                  <TableCell align="center">{row.pname}</TableCell>
                                  <TableCell align="center">{row.productPrice}</TableCell>
                                  <TableCell align="center">{row.qtyNum}</TableCell>
                                  <TableCell align="center" width={60}>

                                    <TextField
                                      size="small"
                                      id="outlined-size-small"
                                      defaultValue={row.aPrice}
                                    />

                                  </TableCell>
                                  <TableCell align="center">{row.rePrice}</TableCell>
                                  <TableCell align="center">
                                    {row.action}
                                    {
                                      <IconButton aria-label="delete">
                                        <EditIcon />
                                      </IconButton>
                                    }
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          {emptyRows > 0 && (
                            <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Card>
                </Stack>
                <Divider variant="middle" />
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                  <LoadingButton
                    size="small"
                    type="button"
                    onClick={() => SubmitForm()}
                    color="secondary"
                    variant="outlined"
                  >
                    {pageProps.submitButtonName}
                  </LoadingButton>
                </Stack>
              </>
            </Stack>
          </Form>
        </FormikProvider>
      </Container>
    </Page>
  );
}
